import { Inject, Injectable } from '@angular/core';
import { RestService } from '@tdwb/core';

@Injectable()
export class IntegrationService {
  constructor(@Inject(RestService) private restService: RestService) {
  }

  sendKeepAlive(): void {
    this.restService.getResource('session.keepalive').get().subscribe();
  }
}
